import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './DecorationServices.css';
import { myAxios } from '../../services/Helper';

const DecorationServices = ({ selectedDecorations, onSelectDecoration, functionId }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await myAxios.get(`/subfunction/getByFunctionID/${functionId}`);
                setServices(response.data.map(service => ({
                    id: service.subFunctionID,
                    name: service.subFunctionName,
                    price: service.subFunctionPrice,
                    description: service.subFunctionDec
                })));
                setLoading(false);
            } catch (err) {
                setError(err.response?.data?.message || 'Failed to fetch services');
                setLoading(false);
            }
        };
        if (functionId) fetchServices();
    }, [functionId]);

    const filteredServices = services.filter(service =>
        service.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const isSelected = (serviceName) =>
        selectedDecorations.some(deco => deco.name === serviceName);

    const handleToggleSelection = (service) => {
        // Ensure price is always parsed as a number
        const serviceWithNumberPrice = {
            ...service,
            price: Number(service.price) || 0
        };
        
        const isAlreadySelected = selectedDecorations.some(deco => deco.name === service.name);
        const updatedSelections = isAlreadySelected
            ? selectedDecorations.filter(deco => deco.name !== service.name)
            : [...selectedDecorations, serviceWithNumberPrice];

        onSelectDecoration(updatedSelections);
    };

    if (loading) {
        return <div className="loading-message">Loading decoration services...</div>;
    }

    if (error) {
        return <div className="error-message">Error: {error}</div>;
    }

    return (
        <div className="decoration-services-container">
            <h2 className="services-title">Decoration Services</h2>
            <p className="services-subtitle">Select decoration packages for your event</p>

            <div className="search-container">
                <div className="input-group">
                    <span className="input-group-icon">
                        <i className="bi bi-search"></i>
                    </span>
                    <input
                        type="text"
                        className="input-group-input"
                        placeholder="Search for decorations"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            <div className="services-card-grid">
                {filteredServices.map((service) => (
                    <div
                        key={service.id}
                        className={`service-card ${isSelected(service.name) ? 'selected' : ''}`}
                    >
                        <div className="service-card-content">
                            <h3 className="service-name">{service.name}</h3>
                            <p className="service-description">{service.description}</p>
                            <div className="service-price">
                                ₹{Number(service.price).toLocaleString()}
                            </div>
                            <button
                                className="add-to-cart-btn"
                                onClick={() => handleToggleSelection(service)}
                            >
                                {isSelected(service.name) ? 'Selected' : 'Select Package'}
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

DecorationServices.propTypes = {
    selectedDecorations: PropTypes.arrayOf(PropTypes.string).isRequired,
    onSelectDecoration: PropTypes.func.isRequired,
    functionId: PropTypes.number.isRequired,
};

export default DecorationServices;

